(() => {
  const root = document.querySelector('[data-mm-product]');
  if (!root) return;
  const packagePrice = root.dataset.mmPackageRegular;
  if (packagePrice) {
    const syncPackagePrice = () => {
      root.querySelectorAll('.kaching-bundles__bar-main').forEach(bar => {
        if (bar.querySelector('.kaching-bundles__bar-title')?.textContent.trim() !== '2 Felt Boards') return;
        const reference = bar.querySelector('.kaching-bundles__bar-full-price');
        if (reference && reference.textContent.trim() !== packagePrice) reference.textContent = packagePrice;
        if (reference) reference.setAttribute('data-a11y-label', 'Original price for two boards:');
      });
    };
    new MutationObserver(syncPackagePrice).observe(formRoot(), {childList:true, subtree:true, characterData:true});
    syncPackagePrice();
  }
  function formRoot() { return root.querySelector('#MMProductForm'); }
  const syncSelectedOffer = () => {
    const bar = [...root.querySelectorAll('.kaching-bundles__bar-main')].find(item => {
      const label = item.closest('label');
      return item.closest('.kaching-bundles__bar')?.classList.contains('kaching-bundles__bar--selected') || (label && document.getElementById(label.htmlFor)?.checked);
    });
    if (!bar) return;
    const price = bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
    const reference = bar.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
    if (!price) return;
    root.querySelectorAll('[data-mm-price]').forEach(el => { if (el.textContent !== price) el.textContent = price; });
    const regular = root.querySelector('.mm-regular-price');
    if (regular && reference && regular.textContent !== reference) regular.textContent = reference;
    const isPair = bar.querySelector('.kaching-bundles__bar-title')?.textContent.trim() === '2 Felt Boards';
    const sale = root.querySelector('.mm-price .mm-sale-label');
    if (sale) { sale.hidden = isPair; sale.style.display = isPair ? 'none' : ''; }
    const offer = root.querySelector('[data-mm-offer]');
    if (offer) {
      const text = isPair ? offer.dataset.mmPairLabel : offer.dataset.mmSingleLabel;
      if (offer.textContent !== text) offer.textContent = text;
    }
  };
  let selectRequestedOffer = true;
  const requestedOfferTitle = new URLSearchParams(location.search).get('bundle') === '2' ? '2 Felt Boards' : '1 Felt Board';
  const selectOfferFromLink = () => {
    if (!selectRequestedOffer) return;
    const bar = [...root.querySelectorAll('.kaching-bundles__bar-main')].find(item => item.querySelector('.kaching-bundles__bar-title')?.textContent.trim() === requestedOfferTitle);
    const label = bar?.closest('label');
    const input = label && document.getElementById(label.htmlFor);
    if (!label || !input) return;
    selectRequestedOffer = false;
    if (!input.checked) label.click();
  };
  const queueOfferSync = () => requestAnimationFrame(() => { selectOfferFromLink(); syncSelectedOffer(); });
  queueOfferSync();
  formRoot().addEventListener('change', queueOfferSync);
  formRoot().addEventListener('click', queueOfferSync);
  new MutationObserver(queueOfferSync).observe(formRoot(), {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class','checked','value']});
  const variants = JSON.parse(root.querySelector('[data-mm-variants]').textContent);
  const form = root.querySelector('#MMProductForm');
  const quantity = root.querySelector('#MMQuantity');
  const main = root.querySelector('#MMProductImage');
  const thumbs = [...root.querySelectorAll('[data-mm-photo]')];
  const radios = [...root.querySelectorAll('[data-mm-variant]')];
  const showImage = (url, alt) => {
    if (!main || !url) return;
    main.removeAttribute('srcset'); main.src = url; main.alt = alt;
    thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mmPhoto === url)));
  };
  const update = (id, changeUrl = true) => {
    const variant = variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    radios.forEach(input => { input.checked = String(input.value) === String(variant.id); });
    root.querySelectorAll('[data-mm-price]').forEach(el => { el.textContent = variant.price; });
    root.querySelectorAll('[data-mm-compare]').forEach(el => { el.textContent = variant.comparePrice || ''; el.hidden = !variant.comparePrice; });
    root.querySelectorAll('[data-mm-color],[data-mm-sticky-color]').forEach(el => { el.textContent = variant.title; });
    root.querySelectorAll('[data-mm-add]').forEach(button => { button.disabled = !variant.available; button.textContent = variant.available ? 'Add to cart' : 'Currently unavailable'; });
    root.querySelector('[data-mm-status]').textContent = variant.available ? 'Available to add to your cart.' : 'This color is not available to order right now.';
    syncSelectedOffer();
    showImage(variant.image, variant.title + ' — ' + root.querySelector('h1').textContent);
    if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
  };
  radios.forEach(input => input.addEventListener('change', () => update(input.value)));
  thumbs.forEach(button => button.addEventListener('click', () => showImage(button.dataset.mmPhoto, button.dataset.mmAlt)));
  const normalizeQuantity = () => { quantity.value = String(Math.max(1, Math.floor(Number(quantity.value) || 1))); };
  root.querySelectorAll('[data-mm-quantity]').forEach(button => button.addEventListener('click', () => { normalizeQuantity(); quantity.value = String(Math.max(1, Number(quantity.value) + Number(button.dataset.mmQuantity))); }));
  quantity.addEventListener('change', normalizeQuantity);
  form.addEventListener('submit', event => { normalizeQuantity(); const selected = variants.find(v => String(v.id) === form.querySelector('[name="id"]:checked')?.value); if (!selected?.available) event.preventDefault(); });
  const sticky = root.querySelector('[data-mm-sticky]');
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(form);
  update(radios.find(input => input.checked)?.value || variants[0]?.id, false);
})();
